import { defineStore } from "pinia";
import { Modal } from "ant-design-vue";

import pb from "@pb/index.json";
import {
  CloudGameCmd,
  UserStatusCmd,
  StoreCmd,
  UserCmd,
} from "@js/web/socket/command";
import DYLongLinkClient from "@js/web/socket/websocket";
import Logger from "@js/logger";
import * as Accounts from "@js/account/index";
import { isGameHtml } from "@js/utils";
import { usePlayGameStore } from "@/store/playGame";
import { useGameListStore } from "@/store/gameList";
import { useloginStore } from "@/store/login";
import IPCCenter from "@js/ipc";
import { EVENTCMD } from "@js/events";
import { IStateType } from "@/js/game/state/IGameState";
import logger from "@js/logger";

const PLAYERSTATUS = pb.nested.yunpb.nested.PlayerStatus.values;
const NodeErrorCode = pb.nested.yunpb.nested.NodeErrorCode.values;

export const useWsMessageStore = defineStore("wsMessage", {
  state: () => {
    return {
      // 推送的数据
      wsMessageData: {} as any,
    };
  },
  actions: {
    setup() {
      console.log("wsMessage websocket 推送注册成功");

      const wsMessageStore = useWsMessageStore();
      const instance = DYLongLinkClient.getInstance();

      [
        CloudGameCmd.CLT_QUE_CHANGE_NOTIFY,
        CloudGameCmd.CLT_GAME_EXIT_NOTIFY,
        CloudGameCmd.CLT_CHARGE_NOTIFY,
        CloudGameCmd.CLT_ENTER_GAME_NOTIFY,
        CloudGameCmd.CLT_RETURN_BATTLEFIELD,
        CloudGameCmd.CLT_ERROR_RESPONSE_ASYNC,
        CloudGameCmd.SVR_KICK_PLAYER,
        CloudGameCmd.CLT_KICK_BY_ADMIN,
        CloudGameCmd.CLT_PLAYER_TIME_OUT,
        CloudGameCmd.CLT_PLAYER_TIME_LEFT,
        UserStatusCmd.UC_UserStatusTakeLeave,
        UserStatusCmd.UC_UserStatusRelogin,
        StoreCmd.NOTICE_USER_PAY_SUCCESS,
        UserCmd.UC_UserInfoUpdate,
      ].forEach((value) => {
        instance.addEventListener(`${value}`, (msg: any) => {
          console.log("instance.addEventListener msg", value, msg, Date.now());
          if (typeof msg === "undefined" || !msg) return;
          const { cmd, obj } = msg;
          Logger.log(`handleSignalMessage ${cmd} ${JSON.stringify(obj)}`);
          wsMessageStore.handleSignalMessage(msg);
        });
      });
    },
    handleSignalMessage(payload: { cmd: number; obj: any }) {
      const playGameStore = usePlayGameStore();
      const gameListStore = useGameListStore();
      const loginStore = useloginStore();
      const { cmd, obj } = payload;
      this.wsMessageData = obj;
      switch (cmd) {
        // 用户购买成功 比如商城购买游戏
        case StoreCmd.NOTICE_USER_PAY_SUCCESS: {
          Logger.log("购买成功");
          gameListStore.update_isBuyGoodSuccess(true);
          // 获取用户钱包
          loginStore.getWallet();
          // 更新用户数据
          loginStore.getPlayer();
          // 通知充值成功了
          loginStore.update_isUserPaySuccess(true);
          break;
        }
        // 排队状态通知(业务服务到客户端)
        case CloudGameCmd.CLT_QUE_CHANGE_NOTIFY: {
          const { waitTime } = obj;
          playGameStore.queueData = {
            ...playGameStore.queueData,
            playerOper: PLAYERSTATUS.IN_QUE,
            waitTime,
          };
          logger.log("接收到排队状态数据的更新");
          playGameStore.handleRefreshQueuePanel(obj);
          break;
        }
        // 通知玩家可以进入游戏(业务服务到客户端)
        case CloudGameCmd.CLT_ENTER_GAME_NOTIFY: {
          playGameStore.isQueueing = false;

          // 错误提示
          if (obj.errorCode !== NodeErrorCode.ErrorNodeSuccess) {
            Accounts.setCurrentGame(null);
            playGameStore.resetModalState();

            Modal.error({
              title: "Tips",
              content: `${obj.errorMsg}(${obj.errorCode})`,
              okText: "OK",
              centered: true,
              onOk: () => {
                console.log("");
              },
            });
            return;
          }
          window.gameStateMgr.setState(IStateType.CAN_ENTER_GAME);
          break;
        }
        case UserStatusCmd.UC_UserStatusTakeLeave: {
          playGameStore.handleKickout();
          Modal.info({
            title: "Tips",
            content:
              "The current account has been logged in elsewhere. Please log in again.",
            okText: "OK",
            centered: true,
            onOk: () => {
              return;
            },
          });
          break;
        }
        case UserStatusCmd.UC_UserStatusRelogin: {
          if (
            obj.deviceId &&
            obj.deviceId.length &&
            Accounts.getUUID() != obj.deviceId
          ) {
            playGameStore.handleKickout();
            Modal.info({
              title: "Tips",
              content:
                "The current account has been logged in elsewhere. Please log in again.",
              okText: "OK",
              centered: true,
              onOk: () => {
                return;
              },
            });
          }
          Logger.log(
            `UC_UserStatusRelogin ${Accounts.getUUID()} ${obj.deviceId}`
          );
          break;
        }
        case UserCmd.UC_UserInfoUpdate: {
          // 接收推送更新用户信息
          loginStore.getPlayer();
          break;
        }
        case CloudGameCmd.CLT_GAME_EXIT_NOTIFY: {
          Accounts.setIsPlayingGame(0);
          if (isGameHtml()) {
            Modal.info({
              title: "Tips",
              content:
                "You do not have enough coins to continue the game, please buy coins",
              okText: "confirm",
              onOk: async () => {
                playGameStore.handleGameExit();
              },
            });
          }
          break;
        }
        default: {
          console.error("后端推送处理失败，推送码:", cmd);
        }
      }
    },
  },
});
